// extracted by mini-css-extract-plugin
module.exports = {"formItem":"UnitInfoPage_formItem__1q4Be","submitWrapper":"UnitInfoPage_submitWrapper__21cqb"};